import {useContext, useEffect} from 'react';
import {AuthContext} from '@/context/Auth/AuthContext';

export const Login = () => {
  const {isReady, isAuthenticated, signInWithRedirect} =
    useContext(AuthContext);

  useEffect(() => {
    if (isReady && !isAuthenticated) {
      signInWithRedirect();
    }
  }, [isReady, isAuthenticated, signInWithRedirect]);

  return null;
};
